import { render, staticRenderFns } from "./LiveChatWidgetCustom.vue?vue&type=template&id=22d21cea&"
import script from "./LiveChatWidgetCustom.vue?vue&type=script&lang=js&"
export * from "./LiveChatWidgetCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports